import moment from 'moment';
import jwtDecode from 'jwt-decode';
import Inventory from '@/entities/Inventory';
import { db, firebase } from '@/vendors/firebase/firebase';

const ls = require('local-storage');

export default {
  async getInventoryByStore(productId) {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log(productId);
    const transformedReponseData = [];
    await db.collection('shops').doc(storeId)
      .collection('listInventory')
      .where('productId', '==', productId)
      .orderBy('date', 'desc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          // const product = { ...doc.data(), date: moment(new Date()).format('DD/MM/YYYY') };
          const date = doc.data().date.toDate();
          const product = { ...doc.data(), date: moment(date).format('DD/MM/YYYY') };
          transformedReponseData.push(new Inventory(product));
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async setQuantityInventory(data) {
    const momentObj = moment(data.date, 'DD/MM/YYYY');
    const dateString = momentObj.format('YYYY-MM-DD');
    const inventoryRef = db.collection('inventory').doc(data.storeId)
      .collection('listing').doc(data.productId)
      .collection('listInventory')
      .doc(dateString);

    const product = {
      ...data,
      date: firebase.firestore.Timestamp.fromDate(new Date(dateString)),
    };

    const result = await inventoryRef.set(product, { merge: true });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(result));
    // return true;
  },
  async getQuantityProductsByStoreAndDate(productId, date) {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    let quantity;
    const inventoryRef = db.collection('inventory').doc(storeId)
      .collection('listing').doc(productId)
      .collection('listInventory')
      .doc(date);

    await inventoryRef.get()
      .then((doc) => {
        if (doc.exists) {
          quantity = doc.data().quantity;
        }
      })
      .catch((error) => {
        console.log('Error getting document:', error);
      });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(quantity));
    // return true;
  },
};
